const customerRoutes = {
	clientes: {
		path: '/clientes',
		name: 'Clientes',
		component: () => import('@/views/Clientes.vue'),
		meta: { title: 'Clientes' }
	},
	crearCliente: {
		path: '/create_cliente',
		name: 'CrearCliente',
		component: () => import('@/views/Create_Cliente.vue'),
		meta: { title: 'Crear Cliente' }
	},
	cliente: {
		path: '/cliente/:id',
		name: 'Cliente',
		component: () => import('@/views/Cliente.vue'),
		meta: { title: 'Cliente' }
	},
	interactions: {
		path: '/interacciones',
		name: 'Interacciones',
		component: () => import('@/views/Interacciones.vue'),
		meta: { title: 'Interacciones Recientes' }
	},
	seguimientoInteracciones: {
		path: '/seguimiento-interacciones',
		name: 'SeguimientoInteracciones',
		component: () => import('@/views/SeguimientoInteracciones.vue'),
		meta: { title: 'Seguimiento de Interacciones' }
	},
	tags: {
		path: '/tags',
		name: 'Tags',
		component: () => import('@/views/Tags.vue'),
		meta: { title: 'Tags' }
	},
	tag: {
		path: '/tag/:id?',
		name: 'Tag',
		component: () => import('@/views/Tag.vue'),
		meta: { title: 'Tag' }
	}
}

export default customerRoutes
